export enum OptionsMealPlanEnum {
  NEW = 'NEW', // Crea y asigna un plan de alimentación al paciente
  SELECT = 'SELECT',
  FILL = 'FILL',
  DEFAULT = 'DEFAULT', // Plan de alimentación asignado al paciente
  CLONE = 'CLONE', // Clona plan de alimentación y lo asigna al paciente
}
